import convertToHtml from '@rei/rich-text-renderer';
import { superScriptify } from './formatText';
import { LTO_PROMO_CONTENT } from './shared-adapters-constants';

export const unwrapParagraphTag = {
  p: (attr, child) => `${child}`,
};

export const getCreditCardCalloutModel = ({
  MEMBER = {}, NON_MEMBER = {}, isMember = false, isLimitedTimeOfferActive = false,
} = {}) => {
  const data = isMember ? MEMBER : NON_MEMBER;

  return {
    ...data,
    heading: convertToHtml(data?.heading, unwrapParagraphTag),
    body: convertToHtml(data?.body, unwrapParagraphTag),
    eyebrow: convertToHtml(data?.eyebrow, unwrapParagraphTag),
    ...(isLimitedTimeOfferActive && LTO_PROMO_CONTENT),
  };
};

export const getTermsConditionsModel = ({
  limitedTimeOfferDisclaimer = '',
  terms: TERMS = [],
  title: titleString,
  disclosureLink,
  isLimitedTimeOfferActive = false,
  showSweepstakesDisclaimer = false,
  sweepstakesDisclaimer = '',
}) => {
  const list = TERMS.map((term) => {
    const symbol = term.symbol === 0 ? '*' : term.symbol;
    const symbolString = symbol ? `<sup>${symbol}</sup>` : '';

    const content = term?.content ? term?.content : convertToHtml(term?.description);

    return `${symbolString}${content}`;
  });

  const title = titleString ? superScriptify(titleString) : titleString;
  let eventTerm = null;

  if (showSweepstakesDisclaimer) {
    eventTerm = sweepstakesDisclaimer;
  } else if (isLimitedTimeOfferActive) {
    eventTerm = limitedTimeOfferDisclaimer;
  }
  const formattedTermsList = [eventTerm, ...list].filter(Boolean);

  return {
    title,
    terms: formattedTermsList,
    disclosureLink,
  };
};
